<template>
  <EOArchitectureWorkshopCheckout :combos="combos" />
</template>

<script>
import EOArchitectureWorkshopCheckout from "@/components/checkout/eoarchitectureworkshop/EOArchitectureWorkshopCheckout.vue";

export default {
  title: "Essential Oil Architecture Workshop",
  name: "EOArchitectureWorkshop",
  components: {
    EOArchitectureWorkshopCheckout,
  },
  props: ["combos"],
};
</script>
